<template>
  <div>
	<div class="data9">
		<div class="data9Left">
			<div class="data9LeftTil">可通电</div>
			<div class="data9LeftBox">
				<div class="data9LeftFor" v-for="(item,index) in njgfList" :key="index">
					<div class="data9LeftForImg">
						<img :src="item.img" />
					</div>
					<div class="data9LeftForName">
						{{item.name}}
					</div>
					<div class="data9LeftForCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
		<div class="data9Right">
			<img src="@/assets/product/page3/znh.png" />
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		njgfList:[
			{
				img:require('@/assets/product/page5/yjyx.png'),
				name:'一键运行',
				cen:'内嵌电源线路，支持多设备接入一键开启和断电，简化日常操作'
			},
			
		]
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data9{
	display: flex;
	padding-bottom: 150px;
	.data9Left{
		flex: 1;
		padding-left: 200px;
		padding-right:40px;
		.data9LeftTil{
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 85px;
		}
		.data9LeftBox{
			.data9LeftFor{
				margin-bottom: 93px;
				.data9LeftForImg{
					margin-bottom: 42px;
					img{
						width: 70px;
						height: 70px;
					}
				}
				.data9LeftForName{
					margin-bottom: 32px;
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
				}
				.data9LeftForCen{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}
	.data9Right{
		width: 60%;
		img{
			width: 100%;
			height: 600px;
		}
	}
}
</style>
